import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { usePermissions } from '@/hooks/usePermissions';
import { isAdminUser } from '@/utils/role';

interface AdminProtectedRouteProps {
  children: ReactNode;
}

/**
 * Composant pour protéger les routes qui nécessitent le rôle admin
 * Redirige les utilisateurs non-admin (user/client) vers /mes-commandes
 * Redirige vers /login si l'utilisateur n'est pas connecté
 */
export const AdminProtectedRoute = ({ children }: AdminProtectedRouteProps) => {
  const { user, loading } = useAuth();
  const { userRole, loading: roleLoading } = usePermissions();

  if (loading || (user && !user.roleName && roleLoading)) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-cranberry"></div>
          <p className="mt-4 text-gray-600">Chargement...</p>
        </div>
      </div>
    );
  }

  // Ne pas rediriger si on vient juste de se connecter (évite les boucles)
  const justLoggedIn = sessionStorage.getItem('justLoggedIn') === 'true';
  if (!user && !justLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  // Admin = roleName "admin" (ID dynamique), pas role_id === 1
  if (user && !isAdminUser(user, userRole)) {
    return <Navigate to="/mes-commandes" replace />;
  }

  return <>{children}</>;
};
